<template>
  <div id="notes-wrap">
    <h2>Notes</h2>
    <template v-for="(note, index) in notes">
      <component 
        :is="detectComponentType(note.component)"
        :title="note.title"
        :content="note.content"
        :componentIndex="index"
        @updateTitle="updateTitle"
        @updateContent="updateContent"
        @deleteNote="removeNote(index)"></component>
    </template>
    <div class="new-notes">
      <select 
        class="select-new-note" 
        v-model="newNoteType">
        <option disabled :selected="selectFirstOption">Select a New Note Type</option>
        <option 
          v-for="note in noteTypes"
          :key="note"
          :value="note">{{ capitalize(note) }}</option>
      </select>
      <button class="add-note" @click="newNote">Add</button>
    </div>
    <SaveButtons @clear="clearNotes"/>
  </div>
</template>
 
<script>
// import Note from './Note.vue';
import TextNote from './TextNote.vue';
import ImageNote from './ImageNote.vue';
import SaveButtons from '../../util/SaveButtons.vue';

// Normal, Image, Draw, Couter
export default {
  name: 'Notes',
  components: { 
    TextNote, 
    ImageNote, 
    SaveButtons 
  },
  data() {
    return {
      newNoteType: '',
      noteTypes: [ 'text', ], // 'image' ],
      // notes: [ { title: 'asdf', content: '', component: TextNote } ],
      selectFirstOption: true
    }
  },
  methods: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    detectComponentType: function(type) {
      switch(type) {
        case 'text':
          return TextNote;
        default:
          break;
      }
    },
    newNote: function() {
      switch (this.newNoteType) {
        case 'text':
          this.notes.push({ title: '', content: '', component: 'text' });
          break;
        // case 'image':
        //   this.notes.push({ title: 'asdf', content: null, component: ImageNote });
        //   break;
      
        default:
          break;
      }
    },
    removeNote: function(index) {
      this.notes.splice(index, 1);
    },
    updateTitle: function(value, index) {
      this.notes[index].title = value;
    },
    updateContent: function(value, index) {
      this.notes[index].content = value;
    },
    clearNotes: function() {
      this.$store.dispatch('clearCharacterNotes');
    }
  },
  computed: {
    notes: {
      get() {
        let temp = this.$store.state.character.notes;
        return temp;
      },
      set(val) {
        
        this.$store.commit('updateCharacterNotes', val);
      }
    }
  }
} 
</script>

<style lang="css">
  #notes-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
  }

  .select-new-note {
    width: 100%;
    -webkit-appearance: none;
    text-align: center;
    font-size: 20px;
    border: 1px solid #2c3e50;
    border-radius: 3px;
    padding: 0.5em;
  }

  .select-new-note:focus {
    outline: none;
  }

  .new-notes {
    display: flex;
    align-items: center;
  }

  .add-note {
    padding: 0.5em;
    margin-left: 1em;
    color: white;
    background: #73C482;
    text-align: center;
    border: none;
    border-radius: 3px;
    font-size: 20px;
  }

  .add-note:focus {
    outline: none;
  }

  .add-note:active {
    border: none;
  }
</style>
